var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !=='Login'&& _vm.$route.name !=='ResetPassword' && _vm.$route.name !== 'ForgotPassword')?_c('Navside'):_vm._e(),_c('router-view',{staticStyle:{"min-height":"100vh"}}),(_vm.$route.name !=='Login' && _vm.$route.name !== 'ResetPassword' && _vm.$route.name !== 'ForgotPassword')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }